<template>
    <require from="../../parent-child-select/parent-child-select"></require>
    <parent-child-select
      objecttypetoadd.bind="'Class'"
      sortable.bind="'true'"
      items.bind="selectedObjectService.selectedObject.classes"
    >
    </parent-child-select>
</template>
